import React from 'react';
import { Section } from '../BaileyHome';
import { Icon } from '../BaileyBits';
import { hapticTick } from '../../../_utils/haptics';
import { SoulMark } from './SoulCards';
import { SOULS, soulHue } from './soul';
import { glanceFor } from './glance';

/**
 * The front desk on the Bailey home, so nobody has to go looking for it or
 * open it to see how it's set up: whether Bailey is answering, where, in
 * which soul, and what it knows. One tap opens the front desk.
 *
 * Never set up: an invitation. Part way through the switch-on: a way back in.
 */
export default function FrontDeskCard({ fd, onCall, onOpen, onSetUp }) {
    if (!fd || !fd.loaded || fd.error) return null;
    const parked = fd.parked && !fd.on ? fd.parked : null;

    if (fd.never || parked) {
        const step = parked ? Math.min(3, Math.max(1, Number(parked.step) || 1)) : 0;
        return (
            <Section label="Front desk">
                <button type="button" className="bly-card fd-invite" onClick={() => { hapticTick(); onSetUp(); }}>
                    <span className="fd-invite-forms" aria-hidden="true">
                        {SOULS.map((p) => <span key={p.id} className="fd-invite-form"><SoulMark hue={p.hue} size={20} /></span>)}
                    </span>
                    <span className="fd-invite-copy">
                        <b>{parked ? 'Finish putting me on your front desk' : 'Let me answer your clients'}</b>
                        <small>{parked
                            ? `Step ${step} of 3, about ${4 - step} ${4 - step === 1 ? 'minute' : 'minutes'} to go.`
                            : 'On your booking page and your phone, day and night. I book people in and take messages. About three minutes to set up.'}</small>
                    </span>
                    <span className="fd-invite-go">{parked ? 'Carry on' : 'Set it up'}</span>
                </button>
            </Section>
        );
    }

    const g = glanceFor({ settings: fd.settings, answers: fd.answers, counts: fd.counts, soul: fd.soul, onCall, hasConversations: fd.conversations.length > 0 });
    return (
        <Section label="Front desk">
            <button type="button" className="bly-card fd-glance" onClick={() => { hapticTick(); onOpen(); }} aria-label={`Front desk. ${g.state}. ${g.title}. Open the front desk`}>
                <span className="fd-glance-top">
                    <span className="fd-soul-tile"><SoulMark hue={soulHue(fd.soul)} size={24} /></span>
                    <span className="fd-glance-copy">
                        <b>{g.title}</b>
                        <small>{g.sub}</small>
                    </span>
                    <span className={`fd-state${g.on ? ' is-live' : ''}${onCall ? ' is-call' : ''}`}>{g.on && <i />}{g.state}</span>
                    <span className="bly-chev" aria-hidden="true"><Icon.Chevron /></span>
                </span>
                <span className="fd-glance-cells">
                    {g.cells.map((c) => (
                        <span key={c.key} className="fd-cell">
                            <small>{c.label}</small>
                            <b className={c.value === 'Off' || c.value === 'Not set up' || c.value === 'None added' ? 'is-quiet' : ''}>{c.value}</b>
                        </span>
                    ))}
                </span>
            </button>
        </Section>
    );
}
